module.exports = __webpack_public_path__ + "lazerSlideAlt.jpg?1a351534cea6fa70a4897e5228944907";